module.exports = __webpack_public_path__ + "public/images/cooking.1f5bdbe9b1910c1d9f894649158d2df0.png";